import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Install-PWA prompt banner. Uses `beforeinstallprompt` event on Chromium.
 * Silently hidden if not installable, already installed, or dismissed.
 */
export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("globo:install-dismissed");
    if (dismissed) return;
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (isStandalone) return;

    const onBIP = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBIP);
    return () => window.removeEventListener("beforeinstallprompt", onBIP);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    setDeferred(null);
    setVisible(false);
  };
  const dismiss = () => {
    localStorage.setItem("globo:install-dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-50 max-w-sm bg-card border border-border rounded-xl shadow-2xl p-4 animate-float-in"
      data-testid="install-prompt"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-sm">Installer Globo</div>
          <p className="text-xs text-muted-foreground mt-0.5">
            Ajoutez l'application à votre écran d'accueil pour un accès rapide.
          </p>
          <div className="mt-3 flex gap-2">
            <Button size="sm" onClick={install} data-testid="install-accept-btn">
              Installer
            </Button>
            <Button size="sm" variant="ghost" onClick={dismiss} data-testid="install-dismiss-btn">
              Plus tard
            </Button>
          </div>
        </div>
        <button className="text-muted-foreground hover:text-foreground" onClick={dismiss} aria-label="Fermer">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
